import { bindCitationPresentation } from './citationBindings.js';
import { normalizeCitationPayload } from './citations.js';

/** Surface declarations are authoritative; only messages without a declaration use legacy display. */
export const selectMessagePresentation = message => {
  const projection = message.message_projection;
  const visible = projection?.surfaces === undefined || (Array.isArray(projection.surfaces) && projection.surfaces.includes('conversation'));
  if (message.role !== 'assistant') return { visible, content: message.content, citationPayload: null, remainingPayload: null };
  return { visible, ...bindCitationPresentation(message.content, normalizeCitationPayload(message.knowledge_citation)) };
};

/** Suppress only the reference App's raw diff presentation when the same round has a preview. */
export const projectedPatchRounds = items => new Set(items.filter(item => item?.roundKey
  && item.payload?.patch_preview_result && item.payload.patch_preview_result.apply?.auto_apply !== true)
  .map(item => item.roundKey));

export const isProjectedPatchText = (item, rounds) => item?.type === 'message' && item.role === 'assistant'
  && rounds.has(item.roundKey) && /^@@\s.+/m.test(item.content ?? '') && /^[+-]\s/m.test(item.content ?? '');
